import React from 'react'

export const ClientLogin = React.lazy(() => import('./clientLogin'))
export const UserLogin = React.lazy(() => import('./userLogin'))
